import React from 'react';
import { motion } from 'framer-motion';
import { Users, MessageSquare, HelpCircle, UserCheck, BookOpen } from 'lucide-react';
const features = [{
  icon: Users,
  text: 'Grupo de alumnos activos'
}, {
  icon: MessageSquare,
  text: 'Ayuda entre compañeros'
}, {
  icon: HelpCircle,
  text: 'Consultas técnicas reales'
}, {
  icon: UserCheck,
  text: 'Seguimiento del docente'
}, {
  icon: BookOpen,
  text: 'Aprendizaje colaborativo'
}];
const messages = [{
  initials: 'JM',
  name: 'Juan M.',
  text: '¿Alguien tiene la planilla de cálculo de carga para una vivienda de 3 ambientes?',
  color: 'bg-blue-500/20 border-blue-500/40 text-blue-300',
  align: 'left'
}, {
  initials: 'ED',
  name: 'Docente',
  text: 'Te la paso ahora. La vimos en la última clase, está en el módulo 3.',
  color: 'bg-ed-green/15 border-ed-green/40 text-ed-green',
  align: 'right',
  badge: 'Docente'
}, {
  initials: 'CR',
  name: 'Carla R.',
  text: '¡Gracias! A mí también me sirve. Estoy con la instalación de mi primer trabajo.',
  color: 'bg-purple-500/20 border-purple-500/40 text-purple-300',
  align: 'left'
}];
export function Community() {
  return <section id="comunidad" className="py-24 bg-ed-black relative border-t border-white/5" data-id="element-61">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-62">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-63">
          {/* Copy */}
          <div data-id="element-64">
            <span className="text-ed-green font-bold tracking-widest uppercase text-sm mb-3 block" data-id="element-65">
              Comunidad
            </span>
            <h2 className="text-4xl sm:text-5xl font-black uppercase tracking-tight text-white mb-5" data-id="element-66">
              Un entorno que <span className="text-ed-green" data-id="element-67">te potencia.</span>
            </h2>
            <p className="text-zinc-400 text-lg mb-8 leading-relaxed" data-id="element-68">
              Comunidad activa + acompañamiento real. Un espacio donde compartís
              dudas, casos y avances con otros alumnos y con el docente.
            </p>

            <ul className="space-y-4 mb-8" data-id="element-69">
              {features.map((f, i) => {
              const Icon = f.icon;
              return <motion.li key={i} initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true,
                margin: '-50px'
              }} transition={{
                duration: 0.4,
                delay: i * 0.08
              }} className="flex items-center gap-3" data-id="element-70">
                    <div className="w-9 h-9 rounded-lg bg-ed-green/10 border border-ed-green/30 flex items-center justify-center shrink-0" data-id="element-71">
                      <Icon className="w-4 h-4 text-ed-green" data-id="element-72" />
                    </div>
                    <span className="text-zinc-200 font-medium" data-id="element-73">{f.text}</span>
                  </motion.li>;
            })}
            </ul>

            <div className="bg-ed-dark border-l-4 border-ed-green rounded-r-xl p-5 shadow-xl" data-id="element-74">
              <p className="text-white font-black text-2xl sm:text-3xl uppercase leading-tight" data-id="element-75">
                Aprender un oficio acompañado{' '}
                <span className="text-ed-green" data-id="element-76">acelera todo.</span>
              </p>
            </div>
          </div>

          {/* Chat Mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-77">
            <div className="absolute inset-0 bg-ed-green/10 blur-3xl rounded-full pointer-events-none" data-id="element-78"></div>

            <div className="relative bg-ed-dark border border-zinc-800 rounded-2xl overflow-hidden shadow-2xl" data-id="element-79">
              {/* Header */}
              <div className="bg-ed-darker border-b border-zinc-800 px-5 py-4 flex items-center gap-3" data-id="element-80">
                <div className="w-10 h-10 rounded-xl bg-ed-green/15 border border-ed-green/30 flex items-center justify-center" data-id="element-81">
                  <Users className="w-5 h-5 text-ed-green" data-id="element-82" />
                </div>
                <div className="flex-grow" data-id="element-83">
                  <div className="text-white font-bold text-sm" data-id="element-84">
                    Comunidad ED · Alumnos
                  </div>
                  <div className="text-xs text-zinc-500 flex items-center gap-1.5" data-id="element-85">
                    <span className="w-1.5 h-1.5 rounded-full bg-ed-green animate-pulse" data-id="element-86"></span>
                    142 alumnos en línea
                  </div>
                </div>
              </div>

              {/* Messages */}
              <div className="p-5 space-y-4" data-id="element-87">
                {messages.map((msg, i) => <motion.div key={i} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true,
                margin: '-50px'
              }} transition={{
                duration: 0.4,
                delay: 0.3 + i * 0.2
              }} className={`flex gap-3 ${msg.align === 'right' ? 'flex-row-reverse' : ''}`} data-id="element-88">
                    <div className={`w-9 h-9 rounded-full border flex items-center justify-center shrink-0 text-xs font-black ${msg.color}`} data-id="element-89">
                      {msg.initials}
                    </div>
                    <div className={`max-w-[80%] ${msg.align === 'right' ? 'text-right' : ''}`} data-id="element-90">
                      <div className="flex items-center gap-2 mb-1" data-id="element-91">
                        <span className="text-xs font-bold text-zinc-400" data-id="element-92">
                          {msg.name}
                        </span>
                        {msg.badge && <span className="text-[9px] font-black uppercase tracking-wider bg-ed-green/15 text-ed-green border border-ed-green/30 px-1.5 py-0.5 rounded" data-id="element-93">
                            {msg.badge}
                          </span>}
                      </div>
                      <div className={`inline-block px-4 py-2.5 rounded-2xl text-sm text-zinc-200 ${msg.align === 'right' ? 'bg-ed-green/10 border border-ed-green/20 rounded-tr-none' : 'bg-zinc-800/80 border border-zinc-700 rounded-tl-none'}`} data-id="element-94">
                        {msg.text}
                      </div>
                    </div>
                  </motion.div>)}

                {/* Typing indicator */}
                <motion.div initial={{
                opacity: 0
              }} whileInView={{
                opacity: 1
              }} viewport={{
                once: true,
                margin: '-50px'
              }} transition={{
                delay: 1.2
              }} className="flex items-center gap-2 pt-2" data-id="element-95">
                  <div className="flex gap-1" data-id="element-96">
                    <span className="w-2 h-2 rounded-full bg-zinc-600 animate-bounce" style={{
                    animationDelay: '0ms'
                  }} data-id="element-97"></span>
                    <span className="w-2 h-2 rounded-full bg-zinc-600 animate-bounce" style={{
                    animationDelay: '150ms'
                  }} data-id="element-98"></span>
                    <span className="w-2 h-2 rounded-full bg-zinc-600 animate-bounce" style={{
                    animationDelay: '300ms'
                  }} data-id="element-99"></span>
                  </div>
                  <span className="text-xs text-zinc-500" data-id="element-100">
                    alguien está escribiendo...
                  </span>
                </motion.div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}